import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const DeleteButtonStyled = styled(Typography)({
  position: 'absolute',
  right: '9rem',
  top: '2.6rem',
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  color: 'red',
  cursor: 'pointer',
  '& svg': {
    fontSize: 24,
  },
});

export const SectionStyled = styled('section')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 5,
  '& svg': {
    fontSize: 90,
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  '@media(max-width: 750px)': {
    display: 'none',
  },
}));

export const MainImageStyled = styled('img')({
  height: '60vh',
  '@media(max-width: 750px)': {
    height: '80vh',
  },
});

export const MobileSectionStyled = styled(Box)(({ theme }) => ({
  '@media(min-width: 751px)': {
    display: 'none',
  },
  '& .buttonContainer': {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'block',
    marginTop: '-40%',
    padding: '0 16px',
    '& button': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.global.white,
    },
  },
}));

export const ThumbStyled = styled(Box)(({ theme }) => ({
  maxWidth: '80%',
  marginTop: 8,
  display: 'flex',
  gap: 8,
  padding: '24px 0',
  overflowX: 'scroll',
  '& .active': {
    border: `3px solid ${theme.palette.primary.main}`,
    borderRadius: 2,
  },
  '@media(max-width: 750px)': {
    maxWidth: '90%',
    padding: 16,
  },
}));
